import { observer } from 'mobx-react-lite'
import { useLocation, useParams } from 'react-router'
import { Box, Button, Divider, Dropdown, IconButton, layoutStore } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { AgentEditCustomTitle } from 'pages/chatbot/ui/AgentEditCustomTitle/AgentEditCustomTitle'
import { AgentEditHeader } from 'pages/chatbot/ui/AgentEditHeader/AgentEditHeader'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'

export const Header = observer(() => {
  const { nameInputStore, isSaving, handleSaveAgent, handlePublishAgent } = useUnifiedAgentContext()
  const { name, setName, error: nameError } = nameInputStore
  const { state: payload } = useLocation()
  const { isViewXs } = layoutStore
  const isActive = false
  const { agentId } = useParams()

  const renderActions = () => [
    {
      iconButtonComponent: (
        <Box display='flex' alignItems='center' gap='8px'>
          {
            <Dropdown
              width={162}
              placement='bottom-start'
              icon={'moreHorizontal'}
              tooltipProps={{
                label: 'Show actions',
                placement: 'top-end',
              }}
              iconButtonProps={{
                fontSize: 20,
                variant: 'contained',
                size: 'medium',
                ariaLabel: 'Actions_showActions',
              }}
              items={[
                ...(isActive
                  ? [
                      {
                        id: 1,
                        label: 'Disable agent',
                        onClick: () => {},
                      },
                    ]
                  : []),
                ...(isViewXs
                  ? [
                      {
                        id: 2,
                        label: 'Test agent',
                        onClick: () => {},
                        disabled: false,
                      },
                    ]
                  : []),
              ]}
            />
          }
          {!isActive && (
            <Button
              text={agentId ? 'Save changes' : 'Save as draft'}
              contained='secondary'
              onClick={handleSaveAgent}
              disabled={isSaving}
            />
          )}
          <Button
            text={isActive ? 'Publish changes' : 'Activate'}
            contained='primary'
            onClick={handlePublishAgent}
            disabled={isSaving}
          />
          <Box display='flex' alignItems='center'>
            <Divider
              orientation='vertical'
              sx={{ height: '16px !important', marginRight: '8px' }}
            />
            <IconButton
              ariaLabel='close_setting'
              icon='close'
              variant='contained'
              color='tertiary'
              size='medium'
              onClick={() =>
                uiStore.changeRoute({
                  path: `/${ChatbotRoutes.root}/${ChatbotRoutes.texting}`,
                })
              }
            />
          </Box>
        </Box>
      ),
    },
  ]

  return (
    <AgentEditHeader
      customTitle={
        <AgentEditCustomTitle
          template={{ icon: 'stars', color: 'var(--purple-70)' }}
          name={name}
          setName={setName}
          error={nameError}
          isAutoFocus={payload?.duplicateId}
        />
      }
      actionsGap={8}
      actions={renderActions()}
    />
  )
})
